import { useMemo } from 'react'

import { AttachmentList } from '@/apps/latest/features/attachments/AttachmentList'
import { PHARMACIST_ATTACHMENT_KINDS } from '@/apps/latest/features/yakureki/attachments'
import { useReleaseChannel } from '@/features/auth'
import type { YakurekiDetail } from '@/shared/types/yakurekiCore'

interface Props {
  event: YakurekiDetail
  // 「まだ SOAP に入っていない資料」を読む差分更新
  onReflect: (ids: string[]) => Promise<void>
}

// 完了後の SOAP カードの最後の「資料」の節 (✦ AI で改善 → 資料。design-book 04-apps/kakeru.md「資料添付 (薬剤師)」)。
// 見出し「資料」(横に まだ入っていない資料の印 ⓘ) が開いたままの紙の節 = 栄養の完了画面と同じ形 (hub log/108 決定 45。
// 閉じた引き出し = 決定 42・44 と header の view = 決定 43 は同日に撤回)。β の店だけ (添付資料タブと同じ gate)。
// 読んだ・飛ばした id は最新の SOAP の版 (在宅は訪問報告書が飛ばした分も)。「反映する」は SOAP がある記録だけ。
export const RecordAttachmentsSection = ({ event, onReflect }: Props) => {
  const { isBeta } = useReleaseChannel()
  const skippedIds = useMemo(
    () => [
      ...(event.soaps?.skipped_attachment_ids ?? []),
      ...(event.soaps?.home_visit_skipped_attachment_ids ?? []),
    ],
    [event.soaps]
  )
  if (!isBeta) return null
  return (
    <AttachmentList
      heading="section"
      yakurekiId={event.id}
      kinds={PHARMACIST_ATTACHMENT_KINDS}
      skippedIds={skippedIds}
      readIds={event.soaps?.attachment_ids}
      onReflect={event.soaps ? onReflect : undefined}
    />
  )
}
